var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2a1 1 0 011 1v1h2a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h2V3a1 1 0 011-1h8zM8 16a1 1 0 100 2 1 1 0 000-2zm3.75.25a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM8 10a1 1 0 100 2 1 1 0 000-2zm3.75.25a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM8.5 5.5h7v-2h-7v2z",
    fill: "currentColor"
  })));
}
SvgDocumentFilled.displayName = 'DocumentFilled';
export default SvgDocumentFilled;